import React, { useEffect, useState } from 'react';
import './StarBackground.css';

const StarBackground = () => {
  const [stars, setStars] = useState([]);
  
  useEffect(() => {
    // Generate random stars
    const generateStars = () => {
      const starCount = 100;  // Number of stars to create
      const newStars = [];
      
      for (let i = 0; i < starCount; i++) {
        newStars.push({
          id: i,
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
          size: `${0.2 + Math.random() * 0.5}rem`,
          animationDelay: `${Math.random() * 5}s`,
          animationDuration: `${3 + Math.random() * 4}s`
        });
      }
      
      setStars(newStars);
    };
    
    generateStars();
  }, []);
  
  return (
    <div className="star-background">
      {stars.map((star) => (
        <div
          key={star.id}
          className="star"
          style={{
            left: star.left,
            top: star.top,
            width: star.size,
            height: star.size,
            animationDelay: star.animationDelay,
            animationDuration: star.animationDuration
          }}
        />
      ))}
    </div>
  );
};

export default StarBackground;